import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommonService } from 'src-adisco/services/common.service';
import { UserService } from 'src/app/admin/core/services/user.service';
import { DynamicDocumentService } from 'src/app/shared/services/dynamic-document.service';

enum Role {
  Partner = '[Extranet - Adhérent]',
  Supplier = '[Extranet - Fournisseur]',
}
@Component({
  selector: 'app-detail-supplier',
  templateUrl: './detail-supplier.component.html',
  styleUrls: ['./detail-supplier.component.css'],
})
export class DetailSupplierComponent implements OnInit {
  detailSupplier!: any;
  contactData: any[] = [];
  listIdContact: any[] = [];
  idSupplier!: any;
  listNews: any[] = [];
  listTrainingNews: any[] = []; // Formations
  listMarketingNews: any[] = [];
  listPromotionNews: any[] = [];
  listFileSupplier: any[] = [];
  itemPdfShow: any;
  visibleItem: boolean = false;
  pdfLoaded: boolean = false;

  logo = 'src-adisco/assets/images/image-default.jpeg'
  roleUser = localStorage.getItem('role');

  constructor(
    private dynamicDocumentService: DynamicDocumentService,
    private _activeRouter: ActivatedRoute,
    private _commonService: CommonService,
    public userService: UserService
  ) { }

  ngOnInit() {
    debugger
    this.getParamUrl()
    this.getDetailSupplier();
  }
  getParamUrl(): void {
    this.idSupplier = '' + this._activeRouter.snapshot.paramMap.get('id');
  }
  getDetailSupplier(): void {
    this.dynamicDocumentService
      .find({
        collectionName: 'dynamic_legal_entity',
        filters: [
          {
            "fieldName": "code",
            "conditions": [
              {
                "type": "EQUALS",
                "value": this.idSupplier
              }
            ]
          }
        ],
        page: 1,
        pageSize: 150
      })
      .subscribe((res: any) => {
        this.detailSupplier = res.content[0];
        if (this.detailSupplier?.logo) {
          this.logo = this.detailSupplier?.logo[0]?.url;
        }
        this.detailSupplier?.linkToNaturalPersons?.forEach((itemContact: any) => {
          this.listIdContact.push(itemContact?.documentId);
        });
        this.getListFile(this.detailSupplier?.linkToResources?.map((item: any) => item?.documentId) || []);
        this.getContact(this.listIdContact);
        this.getListNews();
      });
  }
  getListNews(): void {
    let arrayOfNewsValue: string[] = this.detailSupplier?.linkToNews?.map((item: any) => item?.value) ?? [];
    let filters = [
      {
        "fieldName": "subject",
        "conditions": [
          {
            "type": "IN",
            "value": arrayOfNewsValue,
          }
        ]
      },
      {
        fieldName: "status",
        conditions: [
          {
            type: "EQUALS",
            value: "Publié"
          }
        ]
      },
      {
        fieldName: "lang",
        conditions: [
          {
            type: "EQUALS",
            value: "fr"
          }
        ]
      }
    ];
    this.dynamicDocumentService
      .find(
        {
          collectionName: 'dynamic_news',
          filters: filters,
          sorts: {
            publishedOrder: 'DESC'
          },
          page: 1,
          pageSize: 150,
        },
        true
      )
      .subscribe({
        next: (res) => {
          res?.content.forEach((item: any) => {
            item.supplierName = this.detailSupplier?.companyName;
          });
          this.listNews = res?.content?.filter((item: any) => item?.typeOfNews?.value === "ACTUALITES");
          this.listTrainingNews = res?.content?.filter((item: any) => item?.typeOfNews?.value === "FORMATION");
          this.listMarketingNews = res?.content?.filter((item: any) => item?.typeOfNews?.value === "MARKETING");
          this.listPromotionNews = res?.content?.filter((item: any) => item?.typeOfNews?.value === "PROMOTION");
        },
        error: (error) => {
        },
      });
  }
  getContact(ids: any): void {
    this._commonService.listContact(ids).subscribe({
      next: (res) => {
        this.contactData = res;
      },
      error: (error) => { },
    });
  };

  getListFile(fileIds: any[]): void {
    if (!fileIds.length) {
      return;
    }

    this.dynamicDocumentService
      .findByIds("dynamic_ressource", fileIds)
      .subscribe((dataList: any[]) => {
        const matchingItemsPhoto = dataList.filter((item: any) => {
          const fileName: string[] = item?.title?.split('.') ?? [];
          const fileExtension = fileName.length ? fileName.pop() : null;

          return item?.file?.length > 0 && (item?.typeOfResource?.value === "FOUR" || fileExtension === 'pdf' || item?.file[0]?.url?.includes('.pdf'))
            ;
        });
        matchingItemsPhoto.forEach((item: any) => {
          this.listFileSupplier.push({ nameFile: item?.typeOfResource?.labels?.fr_FR??'Contrat', nameFileDetail: item?.title, urlFile: item?.file[0]?.url, });
        });
      });
  }

  pageProgress(event: any) {
    this.pdfLoaded = false;
  }

  pageRendered(event: any) {
    this.pdfLoaded = true;
  }


  openFile(item: any) {
    this.itemPdfShow = item;
    this.visibleItem = true;
  }

  public onDownload(event: any): void {
    event.preventDefault();
    event.stopPropagation();

    if (!this.itemPdfShow || !this.itemPdfShow.urlFile) {
      return;
    }

    let fileName: string = this.itemPdfShow.urlFile;
    fileName = fileName.substring(fileName.indexOf('/resource-files/') + '/resource-files/'.length);
    fileName = fileName.substring(0, fileName.indexOf('?'));

    if (this.hasUuid(fileName)) {
      fileName = fileName.substring(fileName.indexOf('_') + 1);
    }
    fileName = decodeURIComponent(fileName).toUpperCase().replace(/ /g, '-');
    fileName = fileName.replace(/["'&=$€*\/+\[\]{}|]/g, '-');

    this._commonService.downloadFile(this.itemPdfShow.urlFile, fileName);
  }

  private hasUuid(fileName: string): boolean {
    const uuid: string = fileName.substring(0, fileName.indexOf('_'));
    return (uuid.match(/-/g) || []).length === 4;
  }
}
